import Vue from 'vue'
import Vuex from 'vuex'

import home from './modules/home'
import display from './modules/display'
import zones from './modules/zones'
import deploy from './modules/deploy'
import emergency from './modules/emergency'
import logs from './modules/logs'
import users from './modules/users'
import settings from './modules/settings'
import editor from './modules/editor'
import video from './modules/video'

import {RepositoryFactory} from "../scripts/RepositoryFactory";

const ServiceRepository = RepositoryFactory.get('services');

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
    state: {
        route: null,
        readOnly: 0,
        loading: false,
        error: null,
        errorCount: 0,
        ssoLoginRes: null,
        showLoginDialog: false,
        aceConfig: {
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            fontSize: 12,
            highlightActiveLine: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 4,
            wrap: true,
            showPrintMargin: false,
            showGutter: true,
        },
        navItems: [
            {
                title: 'Home',
                id: 'home',
                icon: 'mdi-home-outline',
                route: '/'
            },
            {
                title: 'Verwaltung Display',
                icon: 'mdi-web',
                id: 'display',
                route: '/display'
            },
            {
                title: 'Verwaltung Video',
                icon: 'mdi-video-outline',
                id: 'video',
                route: '/video'
            },
            {
                title: 'Not-Aus', icon: 'mdi-alert-circle-outline',
                id: 'emergency',
                route: '/emergencystop'
            },
            {
                title: 'Logs',
                icon: 'mdi-file-document-multiple-outline',
                id: 'logs',
                route: '/logs'
            },
            {
                title: 'JSON Editor',
                id: 'json',
                icon: 'mdi-code-json',
                route: '/jsoneditor'
            },
            //{title: 'AdQuality 2.0', icon: 'mdi-seal-variant', route: '/aqt'},
        ],
    },
    getters: {
        readOnly(state) {
            return state.readOnly; //needed for state access in repository.js
        }
    },
    actions: {
        async externalLogin({state}, payload) { //SitetypeId
            let {data} = await ServiceRepository.externalLogin(payload ? payload : state.selectedType.SitetypeId)
            if (!data.notAllowed) {
                this.showLoginDialog = false;
            }
        },
    }
    ,
    mutations: {
        updateReadOnly(state, payload) {
            state.readOnly = payload;
        },
        updateLoading(state, {data}) {
            state.loading = data;
        },
        errorMessage(state, payload) {
            state.error = payload;
            state.errorCount++;
        },
        updateSsoLoginRes(state, payload) {
            if (typeof payload.status !== "undefined" && payload.status === "redirect") {
                state.ssoLoginRes = payload;
            }
            state.showLoginDialog = true;
        },
        closeLoginDialog(state) {
            state.showLoginDialog = false;
        },
        SET_ROUTE(state, route) {
            state.route = route;
        }
    }
    ,
    modules: {
        home,
        display,
        zones,
        deploy,
        emergency,
        logs,
        users,
        settings,
        editor,
        video
    }
})
